export const bootstrapCookiebotAutofocus = () => {
  window.addEventListener("CookiebotOnDialogDisplay", () => {
    const cookiebotOnlyNecessaryButton = document.querySelector<HTMLButtonElement>(
      "#CybotCookiebotDialogBodyButtonsWrapper > button:not(.CybotCookiebotDialogHide)",
    );
    if (cookiebotOnlyNecessaryButton) cookiebotOnlyNecessaryButton.focus();
  });
};
